import type { ReactNode } from 'react'

import { ChromeCollapsibleSection } from '../ChromeCollapsibleSection'
import { chromeMenuCardShellClass } from '../ChromeSurface'
import { createSectionLabelClass } from '../create/createPanelTokens'

type SectionProps = {
  title?: string
  children: ReactNode
  angular: boolean
  className?: string
}

/** 工作流弹窗内分区卡片：标题与内容分层 */
export function WorkflowFormSection({ title, children, angular, className = '' }: SectionProps) {
  return (
    <section className={['px-3 py-3 sm:px-4', chromeMenuCardShellClass(angular, { interactive: false }), className].join(' ')}>
      {title ? <h3 className={createSectionLabelClass()}>{title}</h3> : null}
      <div className={title ? 'mt-3 space-y-3' : 'space-y-3'}>{children}</div>
    </section>
  )
}

type FieldProps = {
  label: string
  children: ReactNode
  hint?: string
}

/** 表单字段：主标签 + 辅助说明 */
export function WorkflowFormField({ label, children, hint }: FieldProps) {
  return (
    <label className="block space-y-1.5">
      <span className="text-sm font-semibold text-ink">{label}</span>
      {hint ? <p className="text-xs leading-relaxed text-ink-soft">{hint}</p> : null}
      {children}
    </label>
  )
}

type CollapsibleProps = {
  title: string
  subtitle?: string
  open: boolean
  onToggle: () => void
  children: ReactNode
  angular: boolean
  className?: string
}

/** 与工作流表单卡片同底色的可折叠区块 */
export function WorkflowCollapsibleSection({
  title,
  subtitle,
  open,
  onToggle,
  children,
  angular,
  className = '',
}: CollapsibleProps) {
  return (
    <ChromeCollapsibleSection
      angular={angular}
      title={title}
      subtitle={subtitle}
      open={open}
      onToggle={onToggle}
      surface="menu"
      className={[
        angular ? 'rounded-none' : 'rounded-[var(--radius-sm)]',
        className,
      ].join(' ')}
    >
      {children}
    </ChromeCollapsibleSection>
  )
}

/** 工作流检查器内嵌子卡片（端口行等） */
export function workflowFormSubcardClass(angular: boolean): string {
  return ['border border-line bg-surface-muted/35 px-2 py-1.5 shadow-card', angular ? 'rounded-none' : 'rounded-[var(--radius-sm)]'].join(' ')
}
